import React, { Component } from 'react';
import Events from './events';
import lsUtil from './lsUtil';

class LoadingPage extends Component {

    constructor(props) {

        super(props);

        this.state = {
            show: false
        };

        this.showing = false;

        this.style = 'loading';

        document.addEventListener(Events.SHOW_LOADING_PAGE, this.show);
        document.addEventListener(Events.HIDE_LOADING_PAGE, this.hide);
        window.loadingPage = this;
    }

    show = (e) => {
        // Fix a race condition when two events are nearly concurrent (show then hide).
        // Fixed by using 'showing' to denote that it is in the process of being shown
        if (!this.state.show || (e && e.detail && e.detail.override)) {
            this.style = e && e.detail && e.detail.style ? e.detail.style : 'loading';
            this.showing = true;
            this.setState({
                show: true,
                message: (e && e.detail && e.detail.loadingPageMessage) ? e.detail.loadingPageMessage : '',
                submessage: (e && e.detail && e.detail.loadingPageSubMessage) ? e.detail.loadingPageSubMessage : '',
                style: this.style
            }, () => { this.showing = false } );
            document.documentElement.classList.add("loading");
        }

    }

    hide = (e) => {
        // Fix a race condition when two events are nearly concurrent (show then hide).
        // Fixed by checking 'showing' variable
        if (this.state.show || this.showing) {
            this.setState({ show: false }, () => { this.showing = false });
            document.documentElement.classList.remove("loading");
        }
    }

    render() {

        var loadingClassName = '';
        var loadingIcon = <div className="loading-activity-indicator"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>;
        if (this.state.style === 'success') {
            loadingIcon = <i className="material-icons loading-success-icon">check_circle</i>
            loadingClassName += ' success';
        }
        if (this.state.style === 'error') {
            loadingIcon = <i className="material-icons loading-success-icon">error_outline</i>
            loadingClassName += ' success';
        }

        if (lsUtil.getLocalStorage() && lsUtil.getLocalStorage().getItem('raven.theme') !== 'light') {
            loadingClassName += ' dark';
        }

        if (lsUtil.getLocalStorage() && lsUtil.getLocalStorage().getItem('raven.vendor')) {
            loadingClassName += ' ' + lsUtil.getLocalStorage().getItem('raven.vendor');
        }

        //loadingClassName += ' active';
        if (this.state.show) loadingClassName += ' active';

        return (
            <div id="loadingPage" className={loadingClassName}>
                <div>{loadingIcon}
                    <h3>{this.state.message}</h3>
                    { this.state.submessage ?
                        <p>{ this.state.submessage} </p> : null
                    }
                </div>
            </div>
        );
    }
}

class ModalLoadingPage extends Component {

    render() {

        var loadingClassName = ["modal-loading-page"];
        if (this.props.style) loadingClassName.push(this.props.style);

        return (
            <div className={loadingClassName.join(" ")}>
                <div>
                    <div className="loading-activity-indicator"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
                    <h3>{this.props.message}</h3>
                    { this.props.submessage ?
                        <p>{ this.props.submessage} </p> : null
                    }
                </div>
            </div>
        );
    }
}

export {
    LoadingPage,
    ModalLoadingPage
}
